import React from "react";

function LiveIcon() {
  return (
    <svg className="live-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
      <path
        fill="#ff5858"
        d="M12 18a6 6 0 110-12 6 6 0 010 12zm0 2.5a8.5 8.5 0 110-17 8.5 8.5 0 010 17zm0-1a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
      ></path>
    </svg>
  );
}

export default LiveIcon;
